export const AsqUrlPrefix = 'asqportal';
export const DdpUrlPrefix = 'ihub';
